const template = require('./fullTextSearchResults.template');
require('./fullTextSearchResults.styles');

import { FullTextSearchHit, FullTextSearchResults, FullTextSearchService } from 'sharebase/services/fullTextSearchService';
import { FullTextSearchDataStore } from 'sharebase/dataStores/fullTextSearchDataStore';
import { ToolbarService } from 'sharebase-app/services/appToolBarService';

export function FullTextSearchResultsDirective() {
	return {
		restrict: 'E',
		template,
		bindToController: true,
		scope: {

		},
		controller: FullTextSearchResultsController,
		controllerAs: 'vm',
		link:(scope)=>{
			scope.$watchCollection('vm.dataStore', newVal =>{
				if(!newVal){return;}

				scope.vm.toolbarService.title = scope.vm.title;
				scope.vm.sortOrder = null;
			});
		}
	};
}

export class FullTextSearchResultsController {
	public static readonly $inject = [
		'$sce',
		'sbFullTextDataStore',
		'sbaToolbarService',
		'gettextCatalog'
	];
	public sortOrder:string;
	public get totalCount(): number {
		return this.dataStore.excludeMine ?  this.dataStore.shared.length : this.dataStore.owned.length + this.dataStore.shared.length;
	}

	public get results(): any[]{
		if(this.dataStore.excludeMine){
			return this.dataStore.shared;
		}
		else if(this.dataStore.onlyMine){
			return this.dataStore.owned;
		}

		return this.dataStore.shared.concat(this.dataStore.owned);
	}

	public retrySearch(){
		this.dataStore.load();
	}

	public $onDestroy(){		

	}

	constructor(
			private readonly $sce: ng.ISCEService, 
			public readonly dataStore: FullTextSearchDataStore, 
			private readonly toolbarService:ToolbarService, 
			private readonly gettextCatalog
		){

		toolbarService.title = this.title;
	}
	
	private get title(): string{
		return this.dataStore.searchTerm ? this.gettextCatalog.getString('Search results for') + ' "' + this.dataStore.searchTerm + '"' : this.gettextCatalog.getString('Search results')
	}
}



// WEBPACK FOOTER //
// ./src/sharebase-app/components/fullTextSearchResults/fullTextSearchResults.ts